import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import "./dataSheet.css";
import Page from "../../components/page/page";
import Header from "../../components/page/header";
import Footer from "../../components/page/footer";
import UserProfileService from "../../services/userProfileService";

let res;

function DataSheet() {

    const location = useLocation()

    useEffect(() => {
        (async () => {
            res = await UserProfileService.getDataSheet(location.state.productionCode);
            setCompressorType(res.data[0].CompressorType)
            setPowerTransmission(res.data[0].PowerTransmission)
            setPressureWorking(res.data[0].PressureWorking)
            setCapacity(res.data[0].Capacity)
            setAmbientWorkingTemprature(res.data[0].AmbientWorkingTemprature)
            setInstallationLocation(res.data[0].AmbientWorkingTemprature)
            setHazardousAreaClasification(res.data[0].HazardousAreaClasification)
            setNoiseLevel(res.data[0].NoiseLevel)
            setDimensionL(res.data[0].DimensionL)
            setDimensionW(res.data[0].DimensionW)
            setDimensionH(res.data[0].DimensionH)
            setWeight(res.data[0].Weight)
            setStartingMethod(res.data[0].StartingMethod)
            setControlPanel(res.data[0].ControlPanel)
            setCoolingMethod(res.data[0].CoolingMethod)
            setConnectionSize(res.data[0].ConnectionSize)
            setStarterPanel(res.data[0].StarterPanel)
            setAirendBrand(res.data[0].AirendBrand)
            setAirendQty(res.data[0].AirendQty)
            setElectroMotorBrand(res.data[0].ElectroMotorBrand)
            setElectroMotorQty(res.data[0].ElectroMotorQty)
            setCoolingFanBrand(res.data[0].CoolingFanBrandotorQty)
            setCoolingFanQty(res.data[0].CoolingFanQty)
            setUnloaderValveBrand(res.data[0].UnloaderValveBrand)
            setUnloaderValveQty(res.data[0].UnloaderValveQty)
            setMinimumPressureValveBrand(res.data[0].MinimumPressureValveBrand)
            setMinimumPressureValveQty(res.data[0].MinimumPressureValveQty)
            setOilTermostaticValveBrand(res.data[0].OilTermostaticValveBrand)
            setOilTermostaticValveQty(res.data[0].OilTermostaticValveQty)
            setAirOilFilterSepratorBrand(res.data[0].AirOilFilterSepratorBrand)
            setAirOilFilterSepratorQty(res.data[0].AirOilFilterSepratorQty)
            setAirIntakeFilterBrand(res.data[0].AirIntakeFilterBrand)
            setAirIntakeFilterQty(res.data[0].AirIntakeFilterQty)
            setTemperatureSensorBrand(res.data[0].TemperatureSensorBrand)
            setTemperatureSensorQty(res.data[0].TemperatureSensorQty)
            setPressureSensorBrand(res.data[0].PressureSensorBrand)
            setPressureSensorQty(res.data[0].PressureSensorQty)
            setPressureIndicatorBrand(res.data[0].PressureIndicatorBrand)
            setPressureIndicatorQty(res.data[0].PressureIndicatorQty)
            setSafetyValveBrand(res.data[0].SafetyValveBrand)
            setSafetyValveQty(res.data[0].SafetyValveQty)
            setCouplingPulleyBrand(res.data[0].CouplingPulleyBrand)
            setCouplingPulleyQty(res.data[0].CoolingFanQty)
            setCouplingPulley2Brand(res.data[0].CouplingPulley2Brand)
            setCouplingPulley2Qty(res.data[0].CouplingPulley2Qty)
            setCoolerModelBrand(res.data[0].CoolerModelBrand)
            setCoolerModelQty(res.data[0].CoolerModelQty)
            setOilFilterBrand(res.data[0].OilFilterBrand)
            setOilFilterQty(res.data[0].OilFilterQty)
            setBeltSizeBrand(res.data[0].BeltSizeBrand)
            setBeltSizeQty(res.data[0].BeltSizeQty)
            setOilCapacityBrand(res.data[0].OilCapacityBrand)
            setOilCapacityQty(res.data[0].OilCapacityQty)
            //DryerType
            setDryerType(res.data[0].DryerType)
            setDewPoint(res.data[0].DewPoint)
            setWorkingPressure(res.data[0].WorkingPressure)
            setFlow_NM3_H(res.data[0].Flow_NM3_H)
            setWorkingTemprature(res.data[0].WorkingTemprature)
            setCycleTime(res.data[0].CycleTime)
            setHydrotestPressure(res.data[0].HydrotestPressure)
            setDesignPressure(res.data[0].DesignPressure)
            setL(res.data[0].L)
            setW(res.data[0].W)
            setH(res.data[0].H)
            setTotalWeight_Kg(res.data[0].TotalWeight_Kg)
            setIn_OutNozzle(res.data[0].In_OutNozzle)
            setPowerConsumption(res.data[0].PowerConsumption)
            setLoaderAndPlatform(res.data[0].LoaderAndPlatform)
            setRalAndTypePaint(res.data[0].RalAndTypePaint)
            setControlBoardTypeBrand(res.data[0].ControlBoardTypeBrand)
            setControlBoardTypeQty(res.data[0].ControlBoardTypeQty)
            setDesiccantType1Brand(res.data[0].DesiccantType1Brand)
            setDesiccantType1Qty(res.data[0].DesiccantType1Qty)
            setDesiccantType2Brand(res.data[0].DesiccantType2Brand)
            setDesiccantType2Qty(res.data[0].DesiccantType2Qty)
            setCeramicBallTypeBrand(res.data[0].CeramicBallTypeBrand)
            setCeramicBallTypeQty(res.data[0].CeramicBallType2Qty)
            setCeramicBallType2Brand(res.data[0].CeramicBallTypeBrand)
            setCeramicBallType2Qty(res.data[0].CeramicBallType2Qty)
            setPressureSwitchBrand(res.data[0].PressureSwitchBrand)
            setPressureSwitchQty(res.data[0].PressureSwitchQty)
            setPressureGaugeBrand(res.data[0].PressureGaugeBrand)
            setPressureGaugeQty(res.data[0].PressureGaugeQty)
            setSilencerBrand(res.data[0].SilencerBrand)
            setSilencerQty(res.data[0].SilencerQty)
            //PSA
            setPsaType(res.data[0].PsaType)
            setOperationalDesign(res.data[0].OperationalDesign)
            setOpeningType(res.data[0].OpeningType)
            setPressureSafetyValveBrand(res.data[0].PressureSafetyValveBrand)
            setPressureSafetyValveQty(res.data[0].PressureSafetyValveQty)
            setVipValve3_8Brand(res.data[0].VipValve3_8Brand)
            setVipValve3_8Qty(res.data[0].VipValve3_8Qty)
            setVipValve3_4Brand(res.data[0].VipValve3_4Brand)
            setVipValve3_4Qty(res.data[0].VipValve3_4Qty)
            setVipValve1Qty(res.data[0].VipValve1Qty)
            setVipValve1Brand(res.data[0].VipValve1Brand)
            setVipValve1_2Qty(res.data[0].VipValve1_2Qty)
            setVipValve1_2Brand(res.data[0].VipValve1_2Brand)
            setVipValve1_1_2Qty(res.data[0].VipValve1_1_2Qty)
            setVipValve1_1_2Brand(res.data[0].VipValve1_1_2Brand)
            setAngleSeatValveQty(res.data[0].AngleSeatValveQty)
            setAngleSeatValveBrand(res.data[0].AngleSeatValveBrand)
            setAdsorberTypeQty(res.data[0].AdsorberTypeQty)
            setAdsorberTypeBrand(res.data[0].AdsorberTypeBrand)
            setCoconutTopOfAdsorbersQty(res.data[0].CoconutTopOfAdsorbersQty)
            setCoconutTopOfAdsorbersBrand(res.data[0].CoconutTopOfAdsorbersBrand)
            setOxygenAnalyzerQty(res.data[0].OxygenAnalyzerQty)
            setOxygenAnalyzerBrand(res.data[0].OxygenAnalyzerBrand)
            setHDMValveBlockQty(res.data[0].HDMValveBlockQty)
            setHDMValveBlockBrand(res.data[0].HDMValveBlockBrand)
            setFlowmeterQty(res.data[0].FlowmeterQty)
            setFlowmeterBrand(res.data[0].FlowmeterBrand)
            setDiffuserQty(res.data[0].DiffuserQty)
            setDiffuserBrand(res.data[0].DiffuserBrand)
        })()
    }, []);

    //Compressor
    const [compressorType, setCompressorType] = useState("در حال بارگذاری");
    const [powerTransmission, setPowerTransmission] = useState("در حال بارگذاری");
    const [pressureWorking, setPressureWorking] = useState("در حال بارگذاری");
    const [capacity, setCapacity] = useState("در حال بارگذاری");
    const [ambientWorkingTemprature, setAmbientWorkingTemprature] = useState("در حال بارگذاری");
    const [InstallationLocation, setInstallationLocation] = useState("در حال بارگذاری");
    const [HazardousAreaClasification, setHazardousAreaClasification] = useState("در حال بارگذاری");
    const [NoiseLevel, setNoiseLevel] = useState("در حال بارگذاری");
    const [DimensionL, setDimensionL] = useState("در حال بارگذاری");
    const [DimensionW, setDimensionW] = useState("در حال بارگذاری");
    const [DimensionH, setDimensionH] = useState("در حال بارگذاری");
    const [Weight, setWeight] = useState("در حال بارگذاری");
    const [StartingMethod, setStartingMethod] = useState("در حال بارگذاری");
    const [ControlPanel, setControlPanel] = useState("در حال بارگذاری");
    const [CoolingMethod, setCoolingMethod] = useState("در حال بارگذاری");
    const [ConnectionSize, setConnectionSize] = useState("در حال بارگذاری");
    const [StarterPanel, setStarterPanel] = useState("در حال بارگذاری");
    const [AirendBrand, setAirendBrand] = useState("در حال بارگذاری");
    const [AirendQty, setAirendQty] = useState("در حال بارگذاری");
    const [ElectroMotorBrand, setElectroMotorBrand] = useState("در حال بارگذاری");
    const [ElectroMotorQty, setElectroMotorQty] = useState("در حال بارگذاری");
    const [CoolingFanBrand, setCoolingFanBrand] = useState("در حال بارگذاری");
    const [CoolingFanQty, setCoolingFanQty] = useState("در حال بارگذاری");
    const [UnloaderValveBrand, setUnloaderValveBrand] = useState("در حال بارگذاری");
    const [UnloaderValveQty, setUnloaderValveQty] = useState("در حال بارگذاری");
    const [MinimumPressureValveBrand, setMinimumPressureValveBrand] = useState("در حال بارگذاری");
    const [MinimumPressureValveQty, setMinimumPressureValveQty] = useState("در حال بارگذاری");
    const [OilTermostaticValveBrand, setOilTermostaticValveBrand] = useState("در حال بارگذاری");
    const [OilTermostaticValveQty, setOilTermostaticValveQty] = useState("در حال بارگذاری");
    const [AirOilFilterSepratorBrand, setAirOilFilterSepratorBrand] = useState("در حال بارگذاری");
    const [AirOilFilterSepratorQty, setAirOilFilterSepratorQty] = useState("در حال بارگذاری");
    const [AirIntakeFilterBrand, setAirIntakeFilterBrand] = useState("در حال بارگذاری");
    const [AirIntakeFilterQty, setAirIntakeFilterQty] = useState("در حال بارگذاری");
    const [TemperatureSensorBrand, setTemperatureSensorBrand] = useState("در حال بارگذاری");
    const [TemperatureSensorQty, setTemperatureSensorQty] = useState("در حال بارگذاری");
    const [PressureSensorBrand, setPressureSensorBrand] = useState("در حال بارگذاری");
    const [PressureSensorQty, setPressureSensorQty] = useState("در حال بارگذاری");
    const [PressureIndicatorBrand, setPressureIndicatorBrand] = useState("در حال بارگذاری");
    const [PressureIndicatorQty, setPressureIndicatorQty] = useState("در حال بارگذاری");
    const [SafetyValveBrand, setSafetyValveBrand] = useState("در حال بارگذاری");
    const [SafetyValveQty, setSafetyValveQty] = useState("در حال بارگذاری");
    const [CouplingPulleyBrand, setCouplingPulleyBrand] = useState("در حال بارگذاری");
    const [CouplingPulleyQty, setCouplingPulleyQty] = useState("در حال بارگذاری");
    const [CouplingPulley2Brand, setCouplingPulley2Brand] = useState("در حال بارگذاری");
    const [CouplingPulley2Qty, setCouplingPulley2Qty] = useState("در حال بارگذاری");
    const [CoolerModelBrand, setCoolerModelBrand] = useState("در حال بارگذاری");
    const [CoolerModelQty, setCoolerModelQty] = useState("در حال بارگذاری");
    const [OilFilterBrand, setOilFilterBrand] = useState("در حال بارگذاری");
    const [OilFilterQty, setOilFilterQty] = useState("در حال بارگذاری");
    const [BeltSizeBrand, setBeltSizeBrand] = useState("در حال بارگذاری");
    const [BeltSizeQty, setBeltSizeQty] = useState("در حال بارگذاری");
    const [OilCapacityBrand, setOilCapacityBrand] = useState("در حال بارگذاری");
    const [OilCapacityQty, setOilCapacityQty] = useState("در حال بارگذاری");
    //Dryer
    const [DryerType, setDryerType] = useState("در حال بارگذاری");
    const [DewPoint, setDewPoint] = useState("در حال بارگذاری");
    const [WorkingPressure, setWorkingPressure] = useState("در حال بارگذاری");
    const [Flow_NM3_H, setFlow_NM3_H] = useState("در حال بارگذاری");
    const [WorkingTemprature, setWorkingTemprature] = useState("در حال بارگذاری");
    const [CycleTime, setCycleTime] = useState("در حال بارگذاری");
    const [HydrotestPressure, setHydrotestPressure] = useState("در حال بارگذاری");
    const [DesignPressure, setDesignPressure] = useState("در حال بارگذاری");
    const [L, setL] = useState("در حال بارگذاری");
    const [W, setW] = useState("در حال بارگذاری");
    const [H, setH] = useState("در حال بارگذاری");
    const [TotalWeight_Kg, setTotalWeight_Kg] = useState("در حال بارگذاری");
    const [In_OutNozzle, setIn_OutNozzle] = useState("در حال بارگذاری");
    const [PowerConsumption, setPowerConsumption] = useState("در حال بارگذاری");
    const [LoaderAndPlatform, setLoaderAndPlatform] = useState("در حال بارگذاری");
    const [RalAndTypePaint, setRalAndTypePaint] = useState("در حال بارگذاری");
    const [ControlBoardTypeBrand, setControlBoardTypeBrand] = useState("در حال بارگذاری");
    const [ControlBoardTypeQty, setControlBoardTypeQty] = useState("در حال بارگذاری");
    const [DesiccantType1Brand, setDesiccantType1Brand] = useState("در حال بارگذاری");
    const [DesiccantType1Qty, setDesiccantType1Qty] = useState("در حال بارگذاری");
    const [DesiccantType2Brand, setDesiccantType2Brand] = useState("در حال بارگذاری");
    const [DesiccantType2Qty, setDesiccantType2Qty] = useState("در حال بارگذاری");
    const [CeramicBallTypeBrand, setCeramicBallTypeBrand] = useState("در حال بارگذاری");
    const [CeramicBallTypeQty, setCeramicBallTypeQty] = useState("در حال بارگذاری");
    const [CeramicBallType2Brand, setCeramicBallType2Brand] = useState("در حال بارگذاری");
    const [CeramicBallType2Qty, setCeramicBallType2Qty] = useState("در حال بارگذاری");
    const [PressureSwitchBrand, setPressureSwitchBrand] = useState("در حال بارگذاری");
    const [PressureSwitchQty, setPressureSwitchQty] = useState("در حال بارگذاری");
    const [PressureGaugeBrand, setPressureGaugeBrand] = useState("در حال بارگذاری");
    const [PressureGaugeQty, setPressureGaugeQty] = useState("در حال بارگذاری");
    const [SilencerBrand, setSilencerBrand] = useState("در حال بارگذاری");
    const [SilencerQty, setSilencerQty] = useState("در حال بارگذاری");
    //PSA
    const [PsaType, setPsaType] = useState("در حال بارگذاری");
    const [OperationalDesign, setOperationalDesign] = useState("در حال بارگذاری");
    const [OpeningType, setOpeningType] = useState("در حال بارگذاری");
    const [PressureSafetyValveBrand, setPressureSafetyValveBrand] = useState("در حال بارگذاری");
    const [PressureSafetyValveQty, setPressureSafetyValveQty] = useState("در حال بارگذاری");
    const [VipValve3_8Brand, setVipValve3_8Brand] = useState("در حال بارگذاری");
    const [VipValve3_8Qty, setVipValve3_8Qty] = useState("در حال بارگذاری");
    const [VipValve3_4Qty, setVipValve3_4Qty] = useState("در حال بارگذاری");
    const [VipValve3_4Brand, setVipValve3_4Brand] = useState("در حال بارگذاری");
    const [VipValve1Qty, setVipValve1Qty] = useState("در حال بارگذاری");
    const [VipValve1Brand, setVipValve1Brand] = useState("در حال بارگذاری");
    const [VipValve1_2Qty, setVipValve1_2Qty] = useState("در حال بارگذاری");
    const [VipValve1_2Brand, setVipValve1_2Brand] = useState("در حال بارگذاری");
    const [VipValve1_1_2Qty, setVipValve1_1_2Qty] = useState("در حال بارگذاری");
    const [VipValve1_1_2Brand, setVipValve1_1_2Brand] = useState("در حال بارگذاری");
    const [AngleSeatValveQty, setAngleSeatValveQty] = useState("در حال بارگذاری");
    const [AngleSeatValveBrand, setAngleSeatValveBrand] = useState("در حال بارگذاری");
    const [AdsorberTypeQty, setAdsorberTypeQty] = useState("در حال بارگذاری");
    const [AdsorberTypeBrand, setAdsorberTypeBrand] = useState("در حال بارگذاری");
    const [CoconutTopOfAdsorbersQty, setCoconutTopOfAdsorbersQty] = useState("در حال بارگذاری");
    const [CoconutTopOfAdsorbersBrand, setCoconutTopOfAdsorbersBrand] = useState("در حال بارگذاری");
    const [OxygenAnalyzerQty, setOxygenAnalyzerQty] = useState("در حال بارگذاری");
    const [OxygenAnalyzerBrand, setOxygenAnalyzerBrand] = useState("در حال بارگذاری");
    const [HDMValveBlockQty, setHDMValveBlockQty] = useState("در حال بارگذاری");
    const [HDMValveBlockBrand, setHDMValveBlockBrand] = useState("در حال بارگذاری");
    const [FlowmeterQty, setFlowmeterQty] = useState("در حال بارگذاری");
    const [FlowmeterBrand, setFlowmeterBrand] = useState("در حال بارگذاری");
    const [DiffuserQty, setDiffuserQty] = useState("در حال بارگذاری");
    const [DiffuserBrand, setDiffuserBrand] = useState("در حال بارگذاری");

    return (
        <Page>
            <Header />

            <section className="container">
                <div className="row hrow headbox-dark">
                    <h3 className="title">اطلاعات دستگاه</h3>
                    <span className="subtitle">{location.state.title}</span>
                    <span className="subtitle">{location.state.productionCode}</span>
                </div>

                <div className="row hrow">

                    <table className="table table-striped">
                        {location.state.codingTitle === "محصولات | کمپرسور Compressor " &&
                            <tbody>
                                <tr>
                                    <td className="key">Compressor Type </td>
                                    <td className="value">{compressorType}</td>
                                    <td className="value"></td>
                                    <td className="value"></td>
                                </tr>
                                <tr>
                                    <td className="key">Power Transmition</td>
                                    <td className="value">{powerTransmission}</td>
                                    <td className="value"></td>
                                    <td className="value"></td>
                                </tr>
                                <tr>
                                    <td className="key">Working Pressure (Barg)</td>
                                    <td className="value">{pressureWorking}</td>
                                    <td className="value"></td>
                                    <td className="value"></td>
                                </tr>
                                <tr>
                                    <td className="key">Flow Rate (FAD) (m3/min)</td>
                                    <td className="value">{capacity}</td>
                                    <td className="value"></td>
                                    <td className="value"></td>
                                </tr>
                                <tr>
                                    <td className="key">min/max ambient Working Tempreture</td>
                                    <td className="value">{ambientWorkingTemprature}</td>
                                    <td className="value"></td>
                                    <td className="value"></td>
                                </tr>
                                <tr>
                                    <td className="key">Installation Location</td>
                                    <td className="value">{InstallationLocation}</td>
                                    <td className="value"></td>
                                    <td className="value"></td>
                                </tr>
                                <tr>
                                    <td className="key">Hazardous Area Classification</td>
                                    <td className="value">{HazardousAreaClasification}</td>
                                    <td className="value"></td>
                                    <td className="value"></td>
                                </tr>
                                <tr>
                                    <td className="key">Noise Level</td>
                                    <td className="value">{NoiseLevel}</td>
                                    <td className="value"></td>
                                    <td className="value"></td>
                                </tr>
                                <tr>
                                    <td className="key">Dimension(L)mm</td>
                                    <td className="value">{DimensionL}</td>
                                    <td className="value"></td>
                                    <td className="value"></td>
                                </tr>
                                <tr>
                                    <td className="key">Dimension(W)mm</td>
                                    <td className="value">{DimensionW}</td>
                                    <td className="value"></td>
                                    <td className="value"></td>
                                </tr>
                                <tr>
                                    <td className="key">Dimension(h)mm</td>
                                    <td className="value">{DimensionH}</td>
                                    <td className="value"></td>
                                    <td className="value"></td>
                                </tr>
                                <tr>
                                    <td className="key">Weigth(Kg)</td>
                                    <td className="value">{Weight}</td>
                                    <td className="value"></td>
                                    <td className="value"></td>
                                </tr>
                                <tr>
                                    <td className="key">Starting Method</td>
                                    <td className="value">{StartingMethod}</td>
                                    <td className="value"></td>
                                    <td className="value"></td>
                                </tr>
                                <tr>
                                    <td className="key">Electrical Panel Equipment</td>
                                    <td className="value">{ControlPanel}</td>
                                    <td className="value"></td>
                                    <td className="value"></td>
                                </tr>
                                <tr>
                                    <td className="key">Cooling Method</td>
                                    <td className="value">{CoolingMethod}</td>
                                    <td className="value"></td>
                                    <td className="value"></td>
                                </tr>
                                <tr>
                                    <td className="key">Compressor Discharge Connection Size(in)</td>
                                    <td className="value">{ConnectionSize}</td>
                                    <td className="value"></td>
                                    <td className="value"></td>
                                </tr>
                                <tr>
                                    <td className="key">Control Board Type</td>
                                    <td className="value">{StarterPanel}</td>
                                    <td className="value"></td>
                                    <td className="value"></td>
                                </tr>
                                <tr>
                                    <td className="key">Air-end</td>
                                    <td className="value">{AirendBrand}</td>
                                    <td className="value">Qty</td>
                                    <td className="value">{AirendQty}</td>
                                </tr>
                                <tr>
                                    <td className="key">Main Electro Motor</td>
                                    <td className="value">{ElectroMotorBrand}</td>
                                    <td className="value">Qty</td>
                                    <td className="value">{ElectroMotorQty}</td>
                                </tr>
                                <tr>
                                    <td className="key">Fan Electro Motor</td>
                                    <td className="value">{CoolingFanBrand}</td>
                                    <td className="value">Qty</td>
                                    <td className="value">{CoolingFanQty}</td>
                                </tr>
                                <tr>
                                    <td className="key">Intake Valve/Unloader(Brand/Model)</td>
                                    <td className="value">{UnloaderValveBrand}</td>
                                    <td className="value">Qty</td>
                                    <td className="value">{UnloaderValveQty}</td>
                                </tr>
                                <tr>
                                    <td className="key">Minimum Pressure Valve(Brand/Model)</td>
                                    <td className="value">{MinimumPressureValveBrand}</td>
                                    <td className="value">Qty</td>
                                    <td className="value">{MinimumPressureValveQty}</td>
                                </tr>
                                <tr>
                                    <td className="key">Oil Termostatic Valve</td>
                                    <td className="value">{OilTermostaticValveBrand}</td>
                                    <td className="value">Qty</td>
                                    <td className="value">{OilTermostaticValveQty}</td>
                                </tr>
                                <tr>
                                    <td className="key">Air/Oil Seprator Filter</td>
                                    <td className="value">{AirOilFilterSepratorBrand}</td>
                                    <td className="value">Qty</td>
                                    <td className="value">{AirOilFilterSepratorQty}</td>
                                </tr>
                                <tr>
                                    <td className="key">Air Intake Filter</td>
                                    <td className="value">{AirIntakeFilterBrand}</td>
                                    <td className="value">Qty</td>
                                    <td className="value">{AirIntakeFilterQty}</td>
                                </tr>
                                <tr>
                                    <td className="key">Temperature Sensor</td>
                                    <td className="value">{TemperatureSensorBrand}</td>
                                    <td className="value">Qty</td>
                                    <td className="value">{TemperatureSensorQty}</td>
                                </tr>
                                <tr>
                                    <td className="key">Pressure Sensor</td>
                                    <td className="value">{PressureSensorBrand}</td>
                                    <td className="value">Qty</td>
                                    <td className="value">{PressureSensorQty}</td>
                                </tr>
                                <tr>
                                    <td className="key">Pressure Gauge</td>
                                    <td className="value">{PressureIndicatorBrand}</td>
                                    <td className="value">Qty</td>
                                    <td className="value">{PressureIndicatorQty}</td>
                                </tr>
                                <tr>
                                    <td className="key">Pressure Safety Valve</td>
                                    <td className="value">{SafetyValveBrand}</td>
                                    <td className="value">Qty</td>
                                    <td className="value">{SafetyValveQty}</td>
                                </tr>
                                <tr>
                                    <td className="key">Coupling/Puuly 1</td>
                                    <td className="value">{CouplingPulleyBrand}</td>
                                    <td className="value">Qty</td>
                                    <td className="value">{CouplingPulleyQty}</td>
                                </tr>
                                <tr>
                                    <td className="key">Coupling/Puuly 2</td>
                                    <td className="value">{CouplingPulley2Brand}</td>
                                    <td className="value">Qty</td>
                                    <td className="value">{CouplingPulley2Qty}</td>
                                </tr>
                                <tr>
                                    <td className="key">Cooler Model</td>
                                    <td className="value">{CoolerModelBrand}</td>
                                    <td className="value">Qty</td>
                                    <td className="value">{CoolerModelQty}</td>
                                </tr>
                                <tr>
                                    <td className="key">Oil Filter</td>
                                    <td className="value">{OilFilterBrand}</td>
                                    <td className="value">Qty</td>
                                    <td className="value">{OilFilterQty}</td>
                                </tr>
                                <tr>
                                    <td className="key">Belt Size</td>
                                    <td className="value">{BeltSizeBrand}</td>
                                    <td className="value">Qty</td>
                                    <td className="value">{BeltSizeQty}</td>
                                </tr>
                                <tr>
                                    <td className="key">Oil Capacity (Liter)</td>
                                    <td className="value">{OilCapacityBrand}</td>
                                    <td className="value">Qty</td>
                                    <td className="value">{OilCapacityQty}</td>
                                </tr>
                            </tbody>
                        }

                        {location.state.codingTitle === "محصولات | درایر Dryer" &&
                            <tbody>
                                <tr>
                                    <td className="key">Dryer Type</td>
                                    <td className="value">{DryerType}</td>
                                    <td className="value"></td>
                                    <td className="value"></td>
                                </tr>
                                <tr>
                                    <td className="key">DewPoint(°C)</td>
                                    <td className="value">{DewPoint}</td>
                                    <td className="value"></td>
                                    <td className="value"></td>
                                </tr>
                                <tr>
                                    <td className="key">WorkingPressure(Barg)</td>
                                    <td className="value">{WorkingPressure}</td>
                                    <td className="value"></td>
                                    <td className="value"></td>
                                </tr>
                                <tr>
                                    <td className="key">Flow Rate (Nm3/Hr)</td>
                                    <td className="value">{Flow_NM3_H}</td>
                                    <td className="value"></td>
                                    <td className="value"></td>
                                </tr>
                                <tr>
                                    <td className="key">min/Max Ambient Working Temprature(°C)</td>
                                    <td className="value">{WorkingTemprature}</td>
                                    <td className="value"></td>
                                    <td className="value"></td>
                                </tr>
                                <tr>
                                    <td className="key">Installation Location</td>
                                    <td className="value">{InstallationLocation}</td>
                                    <td className="value"></td>
                                    <td className="value"></td>
                                </tr>
                                <tr>
                                    <td className="key">Hazardous Area Classification</td>
                                    <td className="value">{HazardousAreaClasification}</td>
                                    <td className="value"></td>
                                    <td className="value"></td>
                                </tr>
                                <tr>
                                    <td className="key">Noise Level</td>
                                    <td className="value">{NoiseLevel}</td>
                                    <td className="value"></td>
                                    <td className="value"></td>
                                </tr>
                                <tr>
                                    <td className="key">Cycle Time</td>
                                    <td className="value">{CycleTime}</td>
                                    <td className="value"></td>
                                    <td className="value"></td>
                                </tr>
                                <tr>
                                    <td className="key">Hydrotest Pressure</td>
                                    <td className="value">{HydrotestPressure}</td>
                                    <td className="value"></td>
                                    <td className="value"></td>
                                </tr>
                                <tr>
                                    <td className="key">DesignPressure</td>
                                    <td className="value">{DesignPressure}</td>
                                    <td className="value"></td>
                                    <td className="value"></td>
                                </tr>
                                <tr>
                                    <td className="key">Dimension(L)(mm)</td>
                                    <td className="value">{L}</td>
                                    <td className="value"></td>
                                    <td className="value"></td>
                                </tr>
                                <tr>
                                    <td className="key">Dimension(W)(mm)</td>
                                    <td className="value">{W}</td>
                                    <td className="value"></td>
                                    <td className="value"></td>
                                </tr>
                                <tr>
                                    <td className="key">Dimension(H)(mm)</td>
                                    <td className="value">{H}</td>
                                    <td className="value"></td>
                                    <td className="value"></td>
                                </tr>
                                <tr>
                                    <td className="key">TotalWeight(Kg)</td>
                                    <td className="value">{TotalWeight_Kg}</td>
                                    <td className="value"></td>
                                    <td className="value"></td>
                                </tr>
                                <tr>
                                    <td className="key">Inlet/Outlet Nozzle(Inch)</td>
                                    <td className="value">{In_OutNozzle}</td>
                                    <td className="value"></td>
                                    <td className="value"></td>
                                </tr>
                                <tr>
                                    <td className="key">Power Consumption(Watt)</td>
                                    <td className="value">{PowerConsumption}</td>
                                    <td className="value"></td>
                                    <td className="value"></td>
                                </tr>
                                <tr>
                                    <td className="key">Ladder & Platform</td>
                                    <td className="value">{LoaderAndPlatform}</td>
                                    <td className="value"></td>
                                    <td className="value"></td>
                                </tr>
                                <tr>
                                    <td className="key">Ral & Type Paint</td>
                                    <td className="value">{RalAndTypePaint}</td>
                                    <td className="value"></td>
                                    <td className="value"></td>
                                </tr>
                                <tr>
                                    <td className="key">Control Board Type</td>
                                    <td className="value">{ControlBoardTypeBrand}</td>
                                    <td className="value">Qty</td>
                                    <td className="value">{ControlBoardTypeQty}</td>
                                </tr>
                                <tr>
                                    <td className="key">Desiccant Type 1 (Kg)</td>
                                    <td className="value">{DesiccantType1Brand}</td>
                                    <td className="value">Qty</td>
                                    <td className="value">{DesiccantType1Qty}</td>
                                </tr>
                                <tr>
                                    <td className="key">Desiccant Type 2 (Kg)</td>
                                    <td className="value">{DesiccantType2Brand}</td>
                                    <td className="value">Qty</td>
                                    <td className="value">{DesiccantType2Qty}</td>
                                </tr>
                                <tr>
                                    <td className="key">Ceramic Ball Type (Kg)</td>
                                    <td className="value">{CeramicBallTypeBrand}</td>
                                    <td className="value">Qty</td>
                                    <td className="value">{CeramicBallTypeQty}</td>
                                </tr>
                                <tr>
                                    <td className="key">Pressure Switch</td>
                                    <td className="value">{PressureSwitchBrand}</td>
                                    <td className="value">Qty</td>
                                    <td className="value">{PressureSwitchQty}</td>
                                </tr>
                                <tr>
                                    <td className="key">Pressure Gauge</td>
                                    <td className="value">{PressureGaugeBrand}</td>
                                    <td className="value">Qty</td>
                                    <td className="value">{PressureGaugeQty}</td>
                                </tr>
                                <tr>
                                    <td className="key">Silencer</td>
                                    <td className="value">{SilencerBrand}</td>
                                    <td className="value">Qty</td>
                                    <td className="value">{SilencerQty}</td>
                                </tr>
                            </tbody>
                        }

                        {location.state.codingTitle === "محصولات | ژنراتور اکسیژن O2 Generator" &&
                            <tbody>
                                <tr>
                                    <td className="key">PSA  Type</td>
                                    <td className="value">{PsaType}</td>
                                    <td className="value"></td>
                                    <td className="value"></td>
                                </tr>
                                <tr>
                                    <td className="key">Design</td>
                                    <td className="value">{OperationalDesign}</td>
                                    <td className="value"></td>
                                    <td className="value"></td>
                                </tr>
                                <tr>
                                    <td className="key">Min/Max Ambient Working Temprature(°C)</td>
                                    <td className="value">{WorkingTemprature}</td>
                                    <td className="value"></td>
                                    <td className="value"></td>
                                </tr>
                                <tr>
                                    <td className="key">Installation Location</td>
                                    <td className="value">{InstallationLocation}</td>
                                    <td className="value"></td>
                                    <td className="value"></td>
                                </tr>
                                <tr>
                                    <td className="key">Hazardous Area Classification</td>
                                    <td className="value">{HazardousAreaClasification}</td>
                                    <td className="value"></td>
                                    <td className="value"></td>
                                </tr>
                                <tr>
                                    <td className="key">Noise Level</td>
                                    <td className="value">{NoiseLevel}</td>
                                    <td className="value"></td>
                                    <td className="value"></td>
                                </tr>
                                <tr>
                                    <td className="key">Hydrotest Pressure</td>
                                    <td className="value">{HydrotestPressure}</td>
                                    <td className="value"></td>
                                    <td className="value"></td>
                                </tr>
                                <tr>
                                    <td className="key">Design Pressure</td>
                                    <td className="value">{DesignPressure}</td>
                                    <td className="value"></td>
                                    <td className="value"></td>
                                </tr>
                                <tr>
                                    <td className="key">Dimension(L)(mm)</td>
                                    <td className="value">{L}</td>
                                    <td className="value"></td>
                                    <td className="value"></td>
                                </tr>
                                <tr>
                                    <td className="key">Dimension(W)(mm)</td>
                                    <td className="value">{W}</td>
                                    <td className="value"></td>
                                    <td className="value"></td>
                                </tr>
                                <tr>
                                    <td className="key">Dimension(H)(mm)</td>
                                    <td className="value">{H}</td>
                                    <td className="value"></td>
                                    <td className="value"></td>
                                </tr>
                                <tr>
                                    <td className="key">Weight(Kg)</td>
                                    <td className="value">{TotalWeight_Kg}</td>
                                    <td className="value"></td>
                                    <td className="value"></td>
                                </tr>
                                <tr>
                                    <td className="key">Inlet/Outlet Nozzle(Inch)</td>
                                    <td className="value">{In_OutNozzle}</td>
                                    <td className="value"></td>
                                    <td className="value"></td>
                                </tr>
                                <tr>
                                    <td className="key">Power Consumption(Watt)</td>
                                    <td className="value">{PowerConsumption}</td>
                                    <td className="value"></td>
                                    <td className="value"></td>
                                </tr>
                                <tr>
                                    <td className="key">Ladder & Platform</td>
                                    <td className="value">{LoaderAndPlatform}</td>
                                    <td className="value"></td>
                                    <td className="value"></td>
                                </tr>
                                <tr>
                                    <td className="key">Openning</td>
                                    <td className="value">{OpeningType}</td>
                                    <td className="value"></td>
                                    <td className="value"></td>
                                </tr>
                                <tr>
                                    <td className="key">Pressure Safety Valve</td>
                                    <td className="value">{PressureSafetyValveBrand}</td>
                                    <td className="value">Qty</td>
                                    <td className="value">{PressureSafetyValveQty}</td>
                                </tr>
                                <tr>
                                    <td className="key">VIP Valive(3.8)</td>
                                    <td className="value">{VipValve3_8Brand}</td>
                                    <td className="value">Qty</td>
                                    <td className="value">{VipValve3_8Qty}</td>
                                </tr>
                                <tr>
                                    <td className="key">VIP Valive(3.4)</td>
                                    <td className="value">{VipValve3_4Brand}</td>
                                    <td className="value">Qty</td>
                                    <td className="value">{VipValve3_4Qty}</td>
                                </tr>
                                <tr>
                                    <td className="key">VIP Valive(1)</td>
                                    <td className="value">{VipValve1Brand}</td>
                                    <td className="value">Qty</td>
                                    <td className="value">{VipValve1Qty}</td>
                                </tr>
                                <tr>
                                    <td className="key">VIP Valive(1.2)</td>
                                    <td className="value">{VipValve1_2Brand}</td>
                                    <td className="value">Qty</td>
                                    <td className="value">{VipValve1_2Qty}</td>
                                </tr>
                                <tr>
                                    <td className="key">VIP Valive(1-1.2)</td>
                                    <td className="value">{VipValve1_1_2Brand}</td>
                                    <td className="value">Qty</td>
                                    <td className="value">{VipValve1_1_2Qty}</td>
                                </tr>
                                <tr>
                                    <td className="key">VIP Valive(1-1.2)</td>
                                    <td className="value">{VipValve1_1_2Brand}</td>
                                    <td className="value">Qty</td>
                                    <td className="value">{VipValve1_1_2Qty}</td>
                                </tr>
                                <tr>
                                    <td className="key">Angle Seat Valve</td>
                                    <td className="value">{AngleSeatValveBrand}</td>
                                    <td className="value">Qty</td>
                                    <td className="value">{AngleSeatValveQty}</td>
                                </tr>
                                <tr>
                                    <td className="key">Control Board Type</td>
                                    <td className="value">{ControlBoardTypeBrand}</td>
                                    <td className="value">Qty</td>
                                    <td className="value">{ControlBoardTypeQty}</td>
                                </tr>
                                <tr>
                                    <td className="key">Desiccant Type 1 (Kg)</td>
                                    <td className="value">{DesiccantType1Brand}</td>
                                    <td className="value">Qty</td>
                                    <td className="value">{DesiccantType1Qty}</td>
                                </tr>
                                <tr>
                                    <td className="key">Adsorber Type (Kg)</td>
                                    <td className="value">{AdsorberTypeBrand}</td>
                                    <td className="value">Qty</td>
                                    <td className="value">{AdsorberTypeQty}</td>
                                </tr>
                                <tr>
                                    <td className="key">Ceramic Ball Type (Kg)</td>
                                    <td className="value">{CeramicBallTypeBrand}</td>
                                    <td className="value">Qty</td>
                                    <td className="value">{CeramicBallTypeQty}</td>
                                </tr>
                                <tr>
                                    <td className="key">Ceramic Ball Type 2 (Kg)</td>
                                    <td className="value">{CeramicBallType2Brand}</td>
                                    <td className="value">Qty</td>
                                    <td className="value">{CeramicBallType2Qty}</td>
                                </tr>
                                <tr>
                                    <td className="key">Coconut Top Of Adsorbers</td>
                                    <td className="value">{CoconutTopOfAdsorbersBrand}</td>
                                    <td className="value">Qty</td>
                                    <td className="value">{CoconutTopOfAdsorbersQty}</td>
                                </tr>
                                <tr>
                                    <td className="key">Silencer</td>
                                    <td className="value">{SilencerBrand}</td>
                                    <td className="value">Qty</td>
                                    <td className="value">{SilencerQty}</td>
                                </tr>
                                <tr>
                                    <td className="key">Pressure Sensor</td>
                                    <td className="value">{PressureSensorBrand}</td>
                                    <td className="value">Qty</td>
                                    <td className="value">{PressureSensorQty}</td>
                                </tr>
                                <tr>
                                    <td className="key">Pressure Gauge</td>
                                    <td className="value">{PressureGaugeBrand}</td>
                                    <td className="value">Qty</td>
                                    <td className="value">{PressureGaugeQty}</td>
                                </tr>
                                <tr>
                                    <td className="key">Oxygen Analyzer</td>
                                    <td className="value">{OxygenAnalyzerBrand}</td>
                                    <td className="value">Qty</td>
                                    <td className="value">{OxygenAnalyzerQty}</td>
                                </tr>
                                <tr>
                                    <td className="key">HDM Valve Block</td>
                                    <td className="value">{HDMValveBlockBrand}</td>
                                    <td className="value">Qty</td>
                                    <td className="value">{HDMValveBlockQty}</td>
                                </tr>
                                <tr>
                                    <td className="key">Flowmeter</td>
                                    <td className="value">{FlowmeterBrand}</td>
                                    <td className="value">Qty</td>
                                    <td className="value">{FlowmeterQty}</td>
                                </tr>
                                <tr>
                                    <td className="key">Deffuser</td>
                                    <td className="value">{DiffuserBrand}</td>
                                    <td className="value">Qty</td>
                                    <td className="value">{DiffuserQty}</td>
                                </tr>
                            </tbody>
                        }
                    </table>
                </div>
            </section>

            <Footer />
        </Page>
    );
}
export default DataSheet;
